import React from 'react';

import { Card, Pagination, Table } from '@unimed-fesp/components';

import { useSelector } from 'react-redux';
import LoadingSpinner from '../LoadingSpinning';
import EmptyRelatorios from './EmptyRelatorios';
import TableBodyRelatorios from './TableBodyRelatorios';
import TableHeaderRelatorios from './TableHeaderRelatorios';

const TableRelatoriosBeneficiario = ({
  openModalInformacoes,
  paginationParams,
  setPaginationParams,
  handleChangePage,
  reprocessarTask,
  obterErrosDeTask,
  downloadRelatorio,
}) => {
  const { getListaArquivos } = useSelector((state) => state.arquivoUpload);

  const propJustify = {
    justifyCenter: getListaArquivos.response.dados.length <= 0,
    justifyStart: getListaArquivos.response.dados.length > 0,
  };

  if (getListaArquivos.loading) {
    return <LoadingSpinner />;
  }

  return (
    <Card margin="0" alignCenter {...propJustify}>
      {getListaArquivos.response.dados.length <= 0 ? (
        <EmptyRelatorios />
      ) : (
        <>
          <Table head={<TableHeaderRelatorios />}>
            <TableBodyRelatorios
              relatorios={getListaArquivos.response.dados}
              openModalInformacoes={openModalInformacoes}
              paginationParams={paginationParams}
              setPaginationParams={setPaginationParams}
              reprocessarTask={reprocessarTask}
              obterErrosDeTask={obterErrosDeTask}
              downloadRelatorio={downloadRelatorio}
            />
          </Table>
          {getListaArquivos.response.total > 10 && (
            <Pagination
              total={getListaArquivos.response.total}
              paginationParams={paginationParams}
              setPaginationParams={setPaginationParams}
              callbackChangePage={handleChangePage}
            />
          )}
        </>
      )}
    </Card>
  );
};

export default TableRelatoriosBeneficiario;
